import I18n from "../../I18n";
import { toast } from "react-toastify";
import jsesc from "jsesc";
import { parseFilter } from "colbi_web_ui/lib/utils";

export const handleMergeRepoData = (props) => {
    const { pushDialog, i18n, mergeRepositoryMetada, params } = props;

    pushDialog("ConfirmDialog", i18n`Merge Data`, {
        title: i18n`Do you want to merge this project collisions?`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            mergeRepositoryMetada(params);
        })
        .catch((e) => console.log("ERROR handleMergeRepoData -> ", e));
};

export const handleDownloadMultipleFiles = (props) => {
    const {
        checkList,
        pushDialog,
        i18n,
        downloadFiles,
        setIsAllSelected,
        setCheckList,
        childList,
    } = props;
    const selectedFiles = (checkList.filter((x) => x.checked && x.status !== "deleted") || []).map(
        (i) => ({
            id: i.id,
            name: i.name,
            status: i.status,
            fileLocation: i.fileLocation,
        }),
    );

    if (selectedFiles.length === 0) return true;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Download Files`, {
        title: i18n`Do you want to download the file${selectedFiles.length > 1 && `s`} ?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            setIsAllSelected(false);
            setCheckList(childList);
            downloadFiles({ files: selectedFiles }, pushDialog, i18n);
        })
        .catch((e) => console.log(e));
};

export const handleReprocessFile = (props) => {
    const {
        checkList,
        pushDialog,
        i18n,
        reprocessFiles,
        setIsAllSelected,
        setCheckList,
        childList,
        params,
    } = props;
    const selectedFiles = (checkList.filter((x) => x.checked && x.status !== "deleted") || []).map(
        (i) => ({
            id: i.id,
            name: i.name,
            status: i.status,
            fileLocation: i.fileLocation,
        }),
    );

    if (selectedFiles.length === 0) return true;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Reprocess Files`, {
        title: i18n`Do you want to reprocess the file${selectedFiles.length > 1 && `s`}?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            setIsAllSelected(false);
            setCheckList(childList);
            reprocessFiles({
                files: selectedFiles.map((i) => parseInt(i.id)),
                projectId: params.projectId,
                fiscalYear: params.fiscalYear || "",
            }).then((res) => res && window.location.reload());
        })
        .catch((e) => console.log(e));
};

export const handleDeleteFilePermanently = (props, toast) => {
    const { pushDialog, i18n, checkList, params, deleteFilePermanently, user } = props;

    const selectedFiles = (checkList.filter((x) => x.checked) || []).map((i) => ({
        id: i.id,
        name: i.name,
        status: i.status,
    }));

    if (selectedFiles.length === 0) return true;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Delete File Permanently`, {
        title: i18n`Are you sure you want to delete permanently the file${
            selectedFiles.length > 1 && `s`
        }?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            deleteFilePermanently({
                fiscalYear: params.fiscalYear || "",
                projectId: params.projectId,
                files: selectedFiles.map((i) => parseInt(i.id)),
                userId: user.id,
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => null);
        })
        .then(() => {
            toast.success(I18n.translate`Deleting selected file(s)!`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                progress: undefined,
            });
        })
        .catch(() => null);
};

export const handleMarkAsDeleted = (props) => {
    const { pushDialog, i18n, checkList, params, setDataFileStatus } = props;

    const selectedFiles = (checkList.filter((x) => x.checked && x.status === "imported") || []).map(
        (i) => ({
            id: i.id,
            name: i.name,
            status: i.status,
        }),
    );

    if (selectedFiles.length === 0) return true;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Mark as Delete`, {
        title: i18n`Are you sure you want to mark as delete the file${
            selectedFiles.length > 1 && `s`
        }?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            setDataFileStatus({
                fiscalYear: params.fiscalYear,
                projectId: params.projectId,
                files: selectedFiles.map((i) => parseInt(i.id)),
                status: "deleted",
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => null);
        })
        .catch(() => null);
};

export const handleMarkAsActived = (props) => {
    const { pushDialog, i18n, checkList, params, setDataFileStatus } = props;

    const selectedFiles = (checkList.filter((x) => x.checked && x.status === "deleted") || []).map(
        (i) => ({
            id: i.id,
            name: i.name,
            status: i.status,
        }),
    );

    if (selectedFiles.length === 0) {
        toast.info(i18n`Files have already been activated.`, {
            position: "top-right",
            autoClose: 2000,
            hideProgressBar: true,
            closeOnClick: true,
            pauseOnHover: false,
            draggable: true,
            progress: undefined,
        });
        return true;
    }

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Mark as Active`, {
        title: i18n`Are you sure you want to mark as active the file${
            selectedFiles.length > 1 && `s`
        }?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            setDataFileStatus({
                fiscalYear: params.fiscalYear,
                projectId: params.projectId,
                files: selectedFiles.map((i) => parseInt(i.id)),
                status: "imported",
            })
                .then((res) => {
                    res && window.location.reload();
                })
                .catch(() => null);
        })
        .catch(() => null);
};

export const handleReprocessRepository = (props) => {
    const { pushDialog, i18n, params, reprocessRepository, user, repositoryStatus } = props;
    pushDialog("ConfirmDialog", i18n`Process All`, {
        title: i18n`Are you sure you want to process repository?`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            if (
                repositoryStatus &&
                (!repositoryStatus.fiscalYear ||
                    !repositoryStatus.fileType ||
                    repositoryStatus.repoStatus === 2 ||
                    repositoryStatus.autoMerge === 1)
            ) {
                toast.error(i18n`No need to reprocess the repository`, {
                    position: "top-right",
                    autoClose: 2000,
                    hideProgressBar: true,
                    closeOnClick: true,
                    pauseOnHover: false,
                    draggable: true,
                    progress: undefined,
                });
                return;
            }
            reprocessRepository({
                fiscalYear: repositoryStatus.fiscalYear,
                projectId: params.projectId,
                fileType: repositoryStatus.fileType,
                userId: user.id,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.reprocess_repository) {
                        toast.success(i18n`Starting reprocessing the repository`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            onClose: () => {
                                window.location.replace(
                                    `/${params.locale}/${params.projectId}/0000/full/repository/activity`,
                                );
                            },
                        });
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        toast.error(i18n`${jsesc(error)}`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch(() => null);
        })
        .catch(() => null);
};

export const handleRequestMergeFromMergeCollisions = (props) => {
    const { pushDialog, i18n, params, reprocessRepository, user, pushNotification, reload } = props;
    pushDialog("ConfirmDialog", i18n`Process All`, {
        title: i18n`Are you sure you want to process repository?`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            const { filter } = params;
            const parsedFilter = parseFilter(filter);
            if (!filter || !parsedFilter || !parsedFilter?.length) {
                throw new Error("Missing filters, please select mandatory filters");
            }

            const dataToRequest = parsedFilter.reduce((acc, elem) => {
                if (elem?.column === "FiscalYear") {
                    acc["fiscalYear"] = elem.filters?.[0].value || null;
                }

                if (elem?.column === "Type") {
                    acc["fileType"] = elem.filters?.[0].value || null;
                }
                return acc;
            }, {});

            if (!dataToRequest?.fiscalYear || !dataToRequest?.fileType) {
                throw new Error("Missing filters, please select mandatory filters");
            }

            reprocessRepository({
                fiscalYear: dataToRequest.fiscalYear,
                projectId: params.projectId,
                fileType: dataToRequest.fileType,
                userId: user.id,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.reprocess_repository) {
                        pushNotification({
                            open: true,
                            message: i18n`Starting reprocessing the repository`,
                            type: "confirmation",
                            timeout: "short",
                        });
                        reload && reload();
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        pushNotification({
                            open: true,
                            message: i18n`${jsesc(error)}`,
                            type: "error",
                            timeout: "short",
                        });
                    }
                })
                .catch(() => null);
        })
        .catch((error) => {
            error &&
                pushNotification({
                    open: true,
                    message: i18n`${jsesc(error)}`,
                    type: "error",
                    timeout: "short",
                });
            return;
        });
};

export const handleAssociationEntityToPackage = (props) => {
    const {
        pushDialog,
        i18n,
        checkList,
        params,
        saveWorkerAssociationPackage,
        setCurrentCheckedList,
        setOriginalCheckedList,
    } = props;
    const selectedFiles = [];
    const removedFiles = [];

    for (const item of checkList) {
        if (item.checked) {
            selectedFiles.push(parseInt(item.id));
        } else {
            removedFiles.push(parseInt(item.id));
        }
    }

    const entityTitle = {
        package_custom_reports: "associate_confirm_message_package_custom_reports",
        package_kpis: "associate_confirm_message_package_kpis",
        package_rules: "associate_confirm_message_package_rules",
    };

    pushDialog("ConfirmDialog", i18n`Package Associate`, {
        title: i18n`${entityTitle[params.entity]}`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            saveWorkerAssociationPackage({
                entity: params.entity,
                packageId: params.id,
                selectItems: selectedFiles,
                removedItems: removedFiles,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.save_worker_association_package) {
                        setCurrentCheckedList(undefined);
                        setOriginalCheckedList(undefined);

                        toast.success(I18n.translate`Package Associated`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            onClose: () => {
                                window.location.reload();
                            },
                        });
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        toast.error(I18n.translate`${jsesc(error)}`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch((e) => {
                    return null;
                });
        })
        .catch(() => null);
};

export const handleFileSubmissionSubmission = (props) => {
    const { checkList, i18n, params, pushModal } = props;

    const selectedFiles = (checkList || []).reduce(
        (acc, elem) => {
            if (elem.checked) {
                for (const key in acc) {
                    if (key === "id") {
                        acc[key].push(parseInt(elem[key]));
                    } else {
                        acc[key].push(elem[key]);
                    }
                }
            }
            return acc;
        },
        {
            id: [],
            name: [],
            hasHighFindings: [],
            period: [],
        },
    );

    const filenames = selectedFiles["name"];
    const fileIds = selectedFiles["id"];
    const filesWithProblems = (selectedFiles["hasHighFindings"] || [])
        .map((value, index) => {
            if (value) {
                return filenames[index];
            }
            return null;
        })
        .filter((r) => r);
    const filesPeriods = selectedFiles["period"];

    pushModal({
        title: i18n`SAF-T Files Submission`,
        data: {
            __typename: "DataFileSubmission",
            filenames,
            fileIds,
            projectId: params.projectId,
            filesWithProblems,
            filePeriods: filesPeriods,
        },
        args: {
            fiscalYear: params.fiscalYear,
            projectId: params.projectId,
        },
        view: "FileSubmissionForm",
        modalType: "center",
    })
        .then(() => {
            toast.success(I18n.translate`Request successfully made`, {
                position: "top-right",
                autoClose: 2000,
                hideProgressBar: true,
                closeOnClick: true,
                pauseOnHover: false,
                draggable: true,
                onClose: window.location.reload(),
            });
        })
        .catch((e) => {
            return null;
        });
};

export const handleRequestDataForOrganizations = (props, fiscalYear) => {
    const { pushDialog, i18n, organizationId, requestDataForOrganizations, user } = props;
    pushDialog("ConfirmDialog", i18n`Calculate Report`, {
        title: i18n`This process will overwrite data for this Report!`,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            requestDataForOrganizations({
                fiscalYear,
                organizationId: organizationId,
                userId: user.id,
            })
                .then((res) => res.json().catch(() => ({})))
                .then((res) => {
                    if (res && res.data && res.data.request_data_for_organization) {
                        toast.success(I18n.translate`Data Requested`, {
                            position: "top-right",
                            autoClose: 3000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                            onClose: window.location.reload(),
                        });
                    } else {
                        const { errors } = res;
                        const error =
                            (errors && errors[0] && errors[0].message) || "error processing";
                        toast.error(I18n.translate`${jsesc(error)}`, {
                            position: "top-right",
                            autoClose: 2000,
                            hideProgressBar: true,
                            closeOnClick: true,
                            pauseOnHover: false,
                            draggable: true,
                            progress: undefined,
                        });
                    }
                })
                .catch(() => null);
        })
        .catch(() => null);
};

export const handleSendSalesInformationEmail = (props) => {
    const { pushDialog, i18n, checkList, params, sendSalesInformationEmail } = props;

    const selectedFiles = (
        checkList.filter((x) => x.checked && x.status === "imported" && x.internalStatus !== 1) ||
        []
    ).map((i) => ({
        id: i.id,
        name: i.name,
        status: i.status,
    }));

    if (selectedFiles.length === 0) return true;

    const filenames = selectedFiles.map((x) => x.name) || "";

    pushDialog("ConfirmDialog", i18n`Submission Information`, {
        title: i18n`Are you sure you want to submit the file${selectedFiles.length > 1 && `s`}?`,
        text: filenames,
        promptText: i18n`Please confirm that you want to proceed!`,
    })
        .then(() => {
            sendSalesInformationEmail(
                params.projectId,
                (selectedFiles || []).map((i) => parseInt(i.id)),
            )
                .then(() => {
                    window.location.reload();
                })
                .catch(() => null);
        })
        .catch(() => null);
};
